import { en as enMessages, fr as frMessages } from './dictionaries/index';
import { Locale } from './locale.const';

export const localeMessagesMap: Record<Locale, typeof enMessages> = {
  [Locale.EN]: enMessages,
  [Locale.FR]: frMessages as typeof enMessages,
};
